export default {
  leftCol: {
    notCollect: 'Emblem no guardara ningún dato durante este proceso',
    proofOfAge: 'Tu prueba de edad no permite a nadie rastrear tu actividad en línea',
  },
  rightColIntro: {
    title: 'Verificación de Edad',
    poweredBy: 'desarrollado por',
    stateLaw: 'La ley estatal requiere que verifiques que tienes 18 años o más',
    emblemPartner: 'Nos hemos asociado con Emblem, un sistema de verificación de edad confiable.',
    safeSimple: 'Es seguro, sencillo y solo tienes que hacer una vez.',
    verifyNow: 'Verificar Ahora',
    alreadyVerified: '¿Ya estas verificado?',
    login: 'Iniciar sesión',
  },
  rightColQR: {
    switchToMobile: 'Cambiar a Dispositivo Móvil',
    verificationRequires: 'Verificación de edad requiere un dispositivo móvil',
    howToContinue: 'Cómo continuar',
    one: '1. Abre la cámara en tu dispositivo móvil.',
    two: '2. Escanea el código QR.',
    three: '3. Sigue los pasos en tu pantalla.',
  },
};